// export let apiBaseUrl = "";
// export var frontEndHomeUrl = "";
// export let GOOGLE_SIGNIN_SECRET = "IC3HYjTOBDnmZvENxLxlpbDU";
const NODE_ENV = process.env.NODE_ENV;

export let GOOGLE_SIGNIN_CLIENT_ID =
  "950788121637-j8i8q92nsshicqoq2q9do5l9skkp2mk5.apps.googleusercontent.com";

export const GOOGLE_CLIENT_ID =
  "238274595666-2jmrs6fjp9lgdocj2rgmau1clr1de775.apps.googleusercontent.com";
export let AWS_CONTACT_EXPORT_URL =
  "https://zonkafeedback-gallery.s3.amazonaws.com";
export let AWS_CONTACT_IMPORT_URL =
  "https://zonkafeedback-gallery.s3.amazonaws.com";
export let oldAppBaseUrl = "https://web.zonkafeedback.com";
export let signupDomain = "zonkasurvey.com/api/v1/";
export let commonLoginUrl = "https://loginaccess.zonkafeedback.com";
export let commonForgotPasswordUrl =
  "https://us1.zonkasurvey.com/api/v1/common/forgotpassword";
export let commonDemoLoginUrl = "https://us1.zonkasurvey.com/api/v1/demoLogin";
export let WEB_LOGIN = "";
export let HOSTNAME = "";

if (NODE_ENV === "development") {
  // apiBaseUrl = "http://localhost:3050/api/v1/";
  // frontEndHomeUrl = "http://localhost:3000/";
  commonLoginUrl = "https://admin-us1.zonkasurvey.com/api/v1/";
  commonForgotPasswordUrl =
    "http://localhost:3050/api/v1/common/forgotpassword";
  AWS_CONTACT_EXPORT_URL = "https://zonkafeedback-gallery.s3.amazonaws.com";
  AWS_CONTACT_IMPORT_URL =
    "https://zonkafeedback-gallery.s3.us-east-2.amazonaws.com";
  WEB_LOGIN = "http://localhost:3000/login";
  HOSTNAME = "localhost";
} else if (NODE_ENV === "nightly") {
  signupDomain = "zonkasurvey.com/api/v1/";
  // apiBaseUrl = "https://us1.zonkasurvey.com/api/v1/";
  // frontEndHomeUrl = "https://web.zonkasurvey.com/";
  commonLoginUrl = "https://admin-us1.zonkasurvey.com/api/v1/";
  commonDemoLoginUrl = "https://us1.zonkasurvey.com/api/v1/demoLogin";
  commonForgotPasswordUrl =
    "https://us1.zonkasurvey.com/api/v1/common/forgotpassword";
  AWS_CONTACT_EXPORT_URL = "https://zonkafeedback-gallery.s3.amazonaws.com";
  AWS_CONTACT_IMPORT_URL =
    "https://zonkafeedback-gallery.s3.us-east-2.amazonaws.com";
  WEB_LOGIN = "https://web.zonkasurvey.com/login";
  HOSTNAME = "web.zonkasurvey.com";
} else if (NODE_ENV === "stage") {
  // commonLoginUrl = "https://prodadminbackendecs.zonkafeedback.com/api/v1/";
  // commonDemoLoginUrl =
  //   "https://prodadminbackendecs.zonkafeedback.com/api/v1/demoLogin";
  // commonForgotPasswordUrl =
  //   "https://prodadminbackendecs.zonkafeedback.com/api/v1/common/forgotpassword";
  // AWS_CONTACT_EXPORT_URL = "https://zonkafeedback-gallery.s3.amazonaws.com";
  // AWS_CONTACT_IMPORT_URL =
  //   "https://zonkafeedback-gallery.s3.amazonaws.com";
  // WEB_LOGIN = "https://prodfrontendecs.zonkafeedback.com/login";
  // HOSTNAME = "prodadminbackendecs.zonkafeedback.com";

  // apiBaseUrl = "https://stgbackend.zonkafeedback.com/api/v1/";
  // frontEndHomeUrl = "https://stgfrontend.zonkafeedback.com/";
  signupDomain = "stgbackend.zonkafeedback.com/api/v1/";
  commonLoginUrl = "https://stgbackend-master.zonkafeedback.com/api/v1/";
  commonDemoLoginUrl =
    "https://stgbackendecs.zonkafeedback.com/api/v1/demoLogin";
  commonForgotPasswordUrl =
    "https://stgbackendecs.zonkafeedback.com/api/v1/common/forgotpassword";
  AWS_CONTACT_EXPORT_URL = "https://zonkafeedback-gallery.s3.amazonaws.com";
  AWS_CONTACT_IMPORT_URL = "https://zonkafeedback-gallery.s3.amazonaws.com";
  WEB_LOGIN = "https://stgfrontendecs.zonkafeedback.com/login";
  HOSTNAME = "stgfrontend.zonkafeedback.com";
} else if (NODE_ENV === "production") {
  signupDomain = "zonkafeedback.com/api/v1/";
  commonLoginUrl = "https://master.zonkafeedback.com/api/v1/";
  commonDemoLoginUrl = "https://us1.zonkafeedback.com/api/v1/demoLogin";
  commonForgotPasswordUrl =
    "https://us1.zonkafeedback.com/api/v1/common/forgotpassword";
  AWS_CONTACT_EXPORT_URL = "https://zonkafeedback-gallery.s3.amazonaws.com";
  AWS_CONTACT_IMPORT_URL = "https://zonkafeedback-gallery.s3.amazonaws.com";
  WEB_LOGIN = "https://platform.zonkafeedback.com/login";
  HOSTNAME = "platform.zonkafeedback.com";
} else {
  //apiBaseUrl = "https://us1.zonkafeedback.com/api/v1/";
  // frontEndHomeUrl = "https://web.zonkasurvey.com/";
  signupDomain = "zonkafeedback.com/api/v1/";
  oldAppBaseUrl = "https://web.zonkafeedback.com";
  commonLoginUrl = "https://us1.zonkasurvey.com/api/v1/";
  commonForgotPasswordUrl =
    "https://us1.zonkasurvey.com/api/v1/common/forgotpassword";
  AWS_CONTACT_EXPORT_URL = "https://zonkafeedback-gallery.s3.amazonaws.com";
  AWS_CONTACT_IMPORT_URL = "https://zonkafeedback-gallery.s3.amazonaws.com";
  WEB_LOGIN = "https://platform.zonkafeedback.com/login";
  HOSTNAME = "platform.zonkafeedback.com";
}



// WEBPACK FOOTER //
// ./src/config/appConfig.js